var _path, _rect, _path2, _path3, _circle, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEqualShares = function SvgEqualShares(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 424,
    height: 94,
    fill: "none",
    viewBox: "0 0 424 94"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D1D5DB",
    d: "M212.517 76.492h-1v-56h1z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 20,
    x: 195.95,
    y: 36.039,
    fill: "#4B5563",
    rx: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D1D5DB",
    d: "M184.517 69.661a3.5 3.5 0 0 1 3.5-3.5h20a4.5 4.5 0 0 0 4.5-4.5v-5.169h-1v5.17a3.5 3.5 0 0 1-3.5 3.5h-20a4.5 4.5 0 0 0-4.5 4.5v5.83h1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D1D5DB",
    d: "M239.517 69.661a3.5 3.5 0 0 0-3.5-3.5h-20a4.5 4.5 0 0 1-4.5-4.5v-5.169h1v5.17a3.5 3.5 0 0 0 3.5 3.5h20a4.5 4.5 0 0 1 4.5 4.5v5.83h-1z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 211.95,
    cy: 16.961,
    r: 8,
    fill: "#4B5563"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 184.05,
    cy: 79.039,
    r: 6,
    fill: "#4B5563"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 212.05,
    cy: 79.039,
    r: 6,
    fill: "#4B5563"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 239.95,
    cy: 79.039,
    r: 6,
    fill: "#4B5563"
  })));
};
export default SvgEqualShares;